import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { FaTrophy, FaStar, FaMedal, FaAward } from 'react-icons/fa';
import '../../stylings/Feature.css';

gsap.registerPlugin(ScrollTrigger);

const highlights = [
  {
    icon: <FaTrophy />,
    award: 'Best School Award',
    desc: 'Recognized for Outstanding Academic Excellence & Holistic Development',
    badge: 'Academic Excellence',
  },
  {
    icon: <FaStar />,
    award: 'Excellence in Education',
    desc: 'Best CBSE School Award – North Delhi Region',
    badge: 'Regional Award',
  },
  {
    icon: <FaMedal />,
    award: 'Sports Achievement',
    desc: 'State Level Champions – Athletics & Football',
    badge: 'Sports Award',
  },
  {
    icon: <FaAward />,
    award: 'Green School Award',
    desc: 'Recognized for Eco-Friendly Campus Initiative',
    badge: 'Environment Award',
  },
];

export default function Feature() {
  const containerRef = useRef(null);

  useEffect(() => {
    const cards = containerRef.current?.querySelectorAll('.feature-card');
    if (!cards) return;
    gsap.fromTo(
      cards,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 0.6,
        stagger: 0.15,
        ease: 'power2.out',
        scrollTrigger: { trigger: containerRef.current, start: 'top 80%' },
      }
    );
  }, []);

  return (
    <section className="feature-section">
      <div className="container-fluid px-5" ref={containerRef}>
        <div className="row g-3">
          {highlights.map((item, i) => (
            <div key={i} className="col-lg-3 col-md-6">
              <div className="feature-card">
                <div className="feature-icon">{item.icon}</div>
                <span className="feature-badge">{item.badge}</span>
                <h5 className="feature-award">{item.award}</h5>
                <p className="feature-desc">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
